export default __webpack_public_path__ + "static/media/WhitneySSm-Bold-Adv_Web.5ace9f37.woff";